module.exports = __webpack_public_path__ + "img/67.fbd8154d.jpg";